import { cva } from '@/styled-system/css';

export const cardFooterRecipe = cva({
  base: {
    marginBlockStart: 'loose',
  },
  variants: {
    divider: {
      true: {
        paddingBlockStart: 'default',
        borderBlockStartWidth: 'default',
        borderBlockStartStyle: 'solid',
        borderBlockStartColor: 'border.muted-alt',
      },
      false: {},
    },
  },
});
